// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "1614775972273/" + ({"214":"polyfills-core-js","748":"polyfills-dom","843":"polyfills-css-shim"}[chunkId] || chunkId) + ".bundle.js";
};